import PropTypes from 'prop-types';
import React from 'react';

const VipButtonContainer = ({ big = false, children }) => {
  return (
    <>
      <div className="button-container">{children}</div>

      <style jsx>{`
        .button-container {
          display: flex;
          justify-content: center;
          margin-bottom: ${big ? '40px' : '10px'};
        }
        :global(.pipe) {
          font-weight: normal;
        }
      `}</style>
    </>
  );
};

VipButtonContainer.propTypes = {
  big: PropTypes.bool,
  children: PropTypes.node,
};

export default VipButtonContainer;
